import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const exportPrivileges = async (payload) => {
  const response = await axiosInstance.post(`${API_URL}/role-privileges/export`, payload);
  return response.data;
};

export const importPrivileges = async (payload) => {
  const response = await axiosInstance.post(`${API_URL}/role-privileges/import`, payload);
  return response.data;
};
